export default {"src":"/_next/static/media/one_percent_white.9127b40e.svg","height":55,"width":50,"blurWidth":0,"blurHeight":0};